module.exports = __webpack_public_path__ + "img/popup-text.aed17090.svg";